import { toast } from 'react-toastify';
import { useState } from 'react';
import { createSessionId } from '../services/session';
import quizApi from '../services/quizApi';


const useStartMockTest = (router, strings) => {
  const [loadingTest, setloadingTest] = useState(false);
  const startMockTest = async () => {
    setloadingTest(true);
    try {
      let selectedState = "Bavaria"
      let state = selectedState.toLowerCase();
      if (state === 'bavaria') {
        state = 'bayern';
      }

      createSessionId();

      const response = await quizApi.createQuestions(`?state=${state}`);

      if (response && response.length > 0) {
        localStorage.setItem("mockTestData", JSON.stringify(response));
        router.push(strings.MockTestPage);
      } else {
        toast.error('Failed to generate quiz. Please try again.');
      }
    } catch (error) {
      console.error('Error generating quiz:', error);
      localStorage.clear();
      toast.error('An error occurred while generating the quiz. Please try again.');
    } finally {
      setloadingTest(false);
    }
  };

  return { startMockTest, loadingTest };
};

export default useStartMockTest;